import { FOOTER_NAV_LINKS } from '../constants/navLinks'
import logo from '../../assets/images/logo-nav-foo-bar.png'
import logoPemprov from '../../assets/images/logo-provkalsel.png'

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-5">
              <div className="h-12 flex items-center mr-0">
                <img src={logoPemprov} className="h-12 w-auto object-contain" alt="Pemprov Kalsel" />
              </div>
              <span className="h-8 w-px bg-slate-700 flex-shrink-0 mx-3" />
              <div className="h-12 flex items-center ml-3">
                <img src={logo} className="h-12 w-auto object-contain" alt="WBS Kalsel" />
              </div>
            </div>
            <div className="font-bold text-white text-base mb-0.5">WBS Pemerintah Provinsi Kalimantan Selatan</div>
            <div className="text-xs text-slate-500 mb-4">Whistleblowing System — Kanal Pelaporan Resmi</div>
            <p className="text-sm leading-relaxed text-slate-500 max-w-sm">
              Platform pelaporan resmi Pemerintah Daerah Provinsi Kalimantan Selatan untuk mendukung tata kelola pemerintahan yang bersih dan akuntabel.
            </p>
            <div className="mt-5 text-xs text-slate-600">
              © {new Date().getFullYear()} Pemerintah Provinsi Kalimantan Selatan. Hak cipta dilindungi.
            </div>
          </div>

          {/* Navigasi */}
          <div>
            <div className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Navigasi</div>
            <ul className="space-y-2.5 text-sm">
              {FOOTER_NAV_LINKS.map(l => (
                <li key={l.label}>
                  <a href={l.href} className="hover:text-blue-400 transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontak */}
          <div>
            <div className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Kontak</div>
            <ul className="space-y-2.5 text-sm">
              <li>Jalan Bangun Praja, Banjarbaru, Kalimantan Selatan 70733 (Kawasan Perkantoran Pemerintah Provinsi Kalimantan Selatan)</li>
              <li className="pt-1">
                <a href="mailto:wbs@kalselprov.go.id" className="hover:text-blue-400 transition-colors">
                  wbs@kalselprov.go.id
                </a>
              </li>
              <li>
                <a href="tel:+625113252525" className="hover:text-blue-400 transition-colors">
                  (0511) 3252525
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-600">
          <span>Dikelola oleh Inspektorat Provinsi Kalimantan Selatan</span>
          <div className="flex gap-5">
            <a href="/syarat-ketentuan" className="hover:text-slate-400 transition-colors">Syarat &amp; Ketentuan</a>
            <a href="/kebijakan-privasi" className="hover:text-slate-400 transition-colors">Kebijakan Privasi</a>
            <a href="/aksesibilitas" className="hover:text-slate-400 transition-colors">Aksesibilitas</a>
            <a href="https://kalselprov.go.id" target="_blank" rel="noopener noreferrer" className="hover:text-slate-400 transition-colors">kalselprov.go.id</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
